/*
*
* File JS per la Homepage
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroBig from 'components/hero-big/hero-big';
import homeSolutions from 'components/home-solutions/home-solutions';
import twoColumnsImage from 'components/two-columns-image/two-columns-image';
import applicationSolutions from '../../components/application-solutions/application-solutions';
import mission from 'components/mission/mission';
import customers from '../../components/customers/customers';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './homepage.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

addEventListener('DOMContentLoaded', (evt) =>
{
    heroBig();
    homeSolutions();
    twoColumnsImage();
    applicationSolutions();
    mission();
    customers();
});

//--------------------------------------------------------------------//